var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage"},[_vm._v(" About page ")])
}
var staticRenderFns = []

export { render, staticRenderFns }